class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
      //alert("event");
    }, 500);

    const facetForm = this.querySelector('form');    
    const applyButton = facetForm.querySelectorAll('.apply-button');
    if(applyButton.length === 0) {
      facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    } else {
      applyButton.forEach(button => {
        button.addEventListener('click', (event) => {
          this.onSubmitHandler(event, true);
          setTimeout(() => {
            button.closest('.filter-drawer-details').querySelector('.modal__close').click();
          }, 500);
        });
      });
    }    
    
    if(facetForm.querySelectorAll('.mobile-facets__checkbox')) {
      const cbItems = facetForm.querySelectorAll('.mobile-facets__checkbox');
      cbItems.forEach(cbItem => {
        cbItem.addEventListener('change', (event) => {
          // console.log("cbItems", cbItem);
          this.onSubmitHandler(event, false);
        });
      });
    }

    FacetFiltersForm.updateFacetCta();

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }  

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    // Keep only search-related parameters and remove filter-related ones
    const currentParams = new URLSearchParams(window.location.search);
    const combinedParams = new URLSearchParams(searchParams);
    // Preserve only the non-filter params (e.g., `q`, `type`)
    currentParams.forEach((value, key) => {
      if (!combinedParams.has(key) && !key.startsWith('filter.') && !key.startsWith('sort_by')) {
        combinedParams.append(key, value);
      }
    });
  
    const finalParams = combinedParams.toString();
    FacetFiltersForm.searchParamsPrev = finalParams;
  
    const sections = FacetFiltersForm.getSections();
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${finalParams}`;
      FacetFiltersForm.renderSectionFromFetch(url, event, finalParams);
    });
  
    if (updateURLHash) FacetFiltersForm.updateURLHash(finalParams);
  }

  static renderSectionFromFetch(url, event, searchParams) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event, searchParams);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        
        document.querySelectorAll('.collection .collection-grid-callout').forEach(el => {                        
          if(searchParams.includes('filter.')){            
            el.setAttribute('hidden', '');
          } else {            
            el.removeAttribute('hidden', '');
          }           
        });                
      });      
  }

  static renderSectionFromCache(filterDataUrl, event, url, searchParams) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event, searchParams);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);

    document.querySelectorAll('.collection .collection-grid-callout').forEach(el => {                    
      if(url.includes('filter.')){        
        el.setAttribute('hidden', '');
      } else {        
        el.removeAttribute('hidden', '');
      }          
    });                
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        // element.classList.add('scroll-trigger--cancel');
      });    
  }

  static renderProductCount(html) {
    // console.log("html", html);
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));

    // console.log("html text", new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').getAttribute("data-pro-cnt"));

    // Temp hide
    //const pro_cnt = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').getAttribute("data-pro-cnt");
    //document.querySelector(".mobile-drawer-filter-result-count").innerHTML = "(" + pro_cnt + ")";
  }

  static renderFilters(html, event, searchParams) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter, .mobile-facets__main .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newElementSelector = document
          .getElementById(closestJSFilterID)
          .classList.contains('mobile-facets__details')
          ? `#${closestJSFilterID} .mobile-facets__close-button`
          : `#${closestJSFilterID} .facets__summary`;
        const newElementToActivate = document.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
      
      
    }
    // TODO: This is temporary. Force the Clear All button to display if any filters active on the URL
    const clear_filters = document.querySelectorAll('.active-list-js');
    if(searchParams.includes('filter')){
      clear_filters.forEach((element) => {
        element.style.display = 'block';
      })
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting', '.ProductCount', '.js-collection-modal-content .facets-layout-list.mobile-facets__list'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    const facetPillsDestination = document.querySelectorAll(`.FacetFiltersPillsForm`);
    const facetPillsSource = html.querySelectorAll(`.FacetFiltersPillsForm`);
    if (facetPillsSource.length > 0 && facetPillsDestination.length > 0 && (facetPillsSource.length === facetPillsDestination.length)) {
      for (let i = 0; i < facetPillsDestination.length; i++) {
        facetPillsDestination[i].innerHTML = facetPillsSource[i].innerHTML;
      }
    }


    html.querySelectorAll('.facets__label').forEach(function (el) {
      if (!el.classList.contains('js-facets__label')) {
        let jsLabel = document.querySelector('.js-collection-modal-content label[for="' + el.getAttribute('for') + '"]');
        
        if(jsLabel){
          if (!el.classList.contains('active')) {
            jsLabel.classList.remove('active');
            jsLabel.querySelector('input').removeAttribute('checked');
          } else {
            jsLabel.classList.add('active');
            jsLabel.querySelector('input').setAttribute('checked', true);                    
          }          
        }        
      }
    });

    if(document.getElementById('FacetFiltersFormMobile')){
      document.getElementById('FacetFiltersFormMobile').closest('menu-drawer')?.bindEvents();
    }    

    FacetFiltersForm.updateFacetCta()
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    const currentParams = new URLSearchParams(window.location.search);
    const newParams = new URLSearchParams(searchParams);

    // Keep non-filter params and merge them with the newParams
    currentParams.forEach((value, key) => {
      if (!newParams.has(key) && !key.startsWith('filter.') && !key.startsWith('sort_by')) {
        newParams.append(key, value);
      }
    });
  
    // Update the URL with only non-filter params and any active filters
    history.pushState({ searchParams: newParams.toString() }, '', `${window.location.pathname}?${newParams.toString()}`);
  }

  static updateFacetCta() {    
    const drawerCTA = document.querySelector('.js-mobile-facets__footer');
    if(new URLSearchParams(window.location.search).toString()){
      drawerCTA.classList.add('active-filters');
    } else {
      drawerCTA.classList.remove('active-filters');
    }
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);    
  }

  onSubmitHandler(event, flag) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('.facet-filters-form form');    
  
    if (event.srcElement.className === 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      var new_url = location.href;
      if(searchParams.indexOf("?") != -1) {
        new_url = location.href.split("?")[0] + searchParams;
      } else {
        new_url = new_url + "?" + searchParams;
      }
      // console.log("searchParams", new_url);
      fetch(new_url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        // console.log("html", html);
        // Temp hide
        //const pro_cnt = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').getAttribute("data-pro-cnt");
        //document.querySelector(".mobile-drawer-filter-result-count").innerHTML = "(" + pro_cnt + ")";
      });     
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);

      if(document.querySelector('.active-facets-alternate__button-remove')){
        document.querySelector('.active-facets-alternate__button-remove').classList.remove('clear-all--active')
      }
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
  
    // Clear all filters by removing filter params from the URL
    const searchParams = new URLSearchParams(window.location.search);
  
    // Remove filter-related params (those starting with 'filter.')
    for (const param of searchParams.keys()) {
      if (param.startsWith('filter.')) {
        searchParams.delete(param);
      }
    }

    // Remove sort_by parameter
    searchParams.delete('sort_by');

    // console.log("searchParams after removal is ", window.location.search);

    // Render the page with only search params remaining
    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }
  
  closeFilter(event) {
    event.preventDefault();    
    const activeCheckboxes = document.querySelectorAll('.facet-checkbox__text')

    event.target.querySelectorAll('.active-facets__value').forEach((activeFacet) => {
      activeCheckboxes.forEach((el) => {        
        if (el.textContent.toLowerCase().trim() === activeFacet.textContent.toLowerCase().trim()) {          
          el.closest('.js-facets__label').querySelector('input').checked = false;
        }
      });
    });
    
    if(this.classList.contains('clear-all-filters')){      
      document.querySelectorAll('.mobile-facets__checkbox').forEach((el) => {        
        el.checked = false;
        if(el.closest('label')) {
          el.closest('label').classList.remove('active');
        }
      });
    }
    
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);    

    if(this.querySelector('.active-facets-alternate__button-remove')){
      this.querySelector('.active-facets-alternate__button-remove').classList.add('clear-all--active')
      this.closest('.facets__list').querySelectorAll('input').forEach(el => el.checked = false)
    }           
  }
}

customElements.define('facet-remove', FacetRemove);
